import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { RoomAccessService } from '../../core/services/room-access.service';

export const roomAccessGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const roomAccessService = inject(RoomAccessService);

  const invitationCode = route.paramMap.get('invitationCode') ?? '';

  if (!invitationCode) {
    return router.createUrlTree(['/unavailable-room']);
  }

  return roomAccessService.validateInvitation(invitationCode).pipe(
    map(({ status }) => {
      if (status === 'join_now') {
        return true;
      }

      if (status === 'waiting_room') {
        return router.createUrlTree(['/login-room']);
      }

      if (status === 'not_ready') {
        return router.createUrlTree(['/room-not-ready']);
      }

      if (status === 'requires_passcode') {
        return router.createUrlTree(['/login-room']);
      }

      return router.createUrlTree(['/unavailable-room']);
    }),
  );
};
